export default "__VITE_ASSET__CrfQKzxJ__"